<template>
	<a v-bind:href="item.Url" class="card card-horizontal card-outer card-callout">
		<div v-if="item.SquareImage" class="card-img">
			<img v-bind:src="item.SquareImage" v-bind:alt="item.AltText" />
		</div>

		<div class="card-content">
			<span class="icon icon-arrow-right asdf"></span>

			<p class="meta">{{ formatDate(item.Date) }} | {{ item.AuthorName }}</p>
			<h2 v-if="item.Title">{{ item.Title }}</h2>
			<p v-if="item.Summary">{{ item.Summary }} <span class="cta-link">Read More</span></p>

			<div v-if="item.Tags" class="card-tags">
				<span>Topics:</span>
				<ul>
					<li v-for="tag in item.Tags">{{ tag.Text }}</li>
				</ul>
			</div>
		</div>
	</a>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item'],
		components: {

		},
		mounted: function () {
			
		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
        },
    }
</script>